import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 3a13 13 0 1 0 0 26c2.689 0 5.512-.81 7.554-2.166a1.002 1.002 0 0 0-1.108-1.667C21.75 26.297 19.276 27 17 27a11 11 0 1 1 11-11c0 3.306-1.36 4-2.5 4s-2.5-.694-2.5-4v-5a1 1 0 0 0-2 0v.533a6 6 0 1 0 .741 8.137c.75 1.5 2.044 2.33 3.759 2.33 2.818 0 4.5-2.242 4.5-6A13.013 13.013 0 0 0 17 3m0 17a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
    />
  </svg>
);
const SvgIconMention = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMention);
export default Memo;
